module.exports = __webpack_public_path__ + "img/corp-darke_2x.ca24d716.jpg";